import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { fmtIDR } from "../lib/format";
import { cn } from "./ui";

const LOAN: Record<string, string> = { active: "Pinjaman aktif", lunas: "Pinjaman lunas" };

export function StudentPicker({ value, onChange, testId }: { value: string; onChange: (id: string) => void; testId?: string }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!q.trim()) { setRows([]); return; }
    setLoading(true);
    const t = setTimeout(() => api.get("/savings/student-search", { params: { q } }).then((r) => setRows(r.data)).catch(() => setRows([])).finally(() => setLoading(false)), 200);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => { if (!value) setSel(null); }, [value]);
  return (
    <div className="relative">
      <input className="yt-input" data-testid={testId} autoFocus placeholder="Ketik nama / ID / NIK / unit siswa dari master data…" value={sel ? `${sel.name} · ${sel.internal_id}` : q} onFocus={() => setOpen(true)} onChange={(e) => { setSel(null); onChange(""); setQ(e.target.value); setOpen(true); }} />
      {open && !sel && q.trim() && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto rounded-md border bg-popover shadow-lg" data-testid={testId ? `${testId}-options` : undefined}>
          {loading && rows.length === 0 && <p className="px-3 py-2 text-xs text-muted-foreground">Mencari…</p>}
          {!loading && rows.length === 0 && <p className="px-3 py-2 text-xs text-muted-foreground" data-testid={testId ? `${testId}-empty` : undefined}>Tidak ditemukan di master data siswa. Tambahkan dulu di Siswa & Pinjaman.</p>}
          {rows.map((s) => (
            <button type="button" key={s.id} onClick={() => { setSel(s); onChange(s.id); setOpen(false); }} data-testid={testId ? `${testId}-opt-${s.internal_id}` : undefined} className={cn("w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center justify-between gap-2")}>
              <span><span className="font-medium">{s.name}</span> <span className="text-muted-foreground text-xs num">· {s.internal_id}{s.unit ? ` · ${s.unit}` : ""}</span></span>
              <span className="text-[10px] text-muted-foreground whitespace-nowrap num">{s.loan_status ? LOAN[s.loan_status] || s.loan_status : "Tanpa pinjaman"}{s.savings_balance ? ` · simpanan ${fmtIDR(s.savings_balance)}` : ""}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
